function parseSettings(userSettings) {
  if (!userSettings) {
    return null;
  }
  
  // if (typeof settings === 'object'){
  //   return settings;
  // }

  const obj = {};
  userSettings.map((item) => {
    obj[item.type] = item.value;
  });
  return obj;
}

export default parseSettings;
